import { initialState } from "src/modals/embedded-integration-v2/constants/initialState"

export const initialPurchaseCollapsibleLinkDynamicFieldState = {
    sectionTitle: { ...initialState },
    sectionContent: { ...initialState },
}
